import {
    SET_BREAKPOINT,
    SHOW_GLOBAL_MESSAGE,
    TIME_EXPIRED
} from './globalConstants';

const updateBreakpoint = (breakpoint:any) => ({
    type: SET_BREAKPOINT,
    breakpoint
});

const showGlobalMessage = (messageType:string) => ({
    type: SHOW_GLOBAL_MESSAGE,
    messageType
});

const timerExpired = (value: boolean) => ({
    type: TIME_EXPIRED,
    payload: value
})
export {
    updateBreakpoint,
    showGlobalMessage,
    timerExpired
};

